import { Clock3, Info } from 'lucide-react';
import { useI18n } from '../i18n';

export default function RegistrationClubNotice({ known, club, team }: { known: boolean | null; club: string; team: string }) {
  const { t } = useI18n();
  if (known === false) return null;
  const Icon = known ? Clock3 : Info;
  return <section role="status" className="flex gap-3 border-y border-slate-200 py-3 text-sm text-slate-600">
    <Icon size={20} className="mt-0.5 shrink-0" aria-hidden="true" />
    <div className="min-w-0">
      <h2 className="font-semibold text-slate-900">{t(known ? 'register_known_club_title' : 'register_club_check_title')}</h2>
      <p className="mt-1 leading-6 break-words">{t(known ? 'register_known_club_description' : 'register_club_check_description', { club, team })}</p>
    </div>
  </section>;
}
